module.exports = __webpack_public_path__ + "../resources/img/pro.425cb152.png";